import { ACCESS_TO_DOCUMENT_TYPES } from "@/static/accessToDocumentTypes";
import { USER_TYPE } from "@/static/userTypes";
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class AutoSendMailConfigurationUserType {
  @Expose()
  @IsEnum(USER_TYPE)
  userTypeEnum!: USER_TYPE;
  @Expose()
  @IsBoolean()
  isAutoSendMail!: boolean;
}

export class EditAutoSendMailConfiguration {
  @Expose()
  @IsBoolean()
  isEnabled!: boolean;
  @Expose()
  @IsNumber()
  mailConfigurationId!: number;
  @Expose()
  @IsEnum(ACCESS_TO_DOCUMENT_TYPES)
  accessTypeToDocument!: ACCESS_TO_DOCUMENT_TYPES;
  @Expose()
  @IsOptional()
  @IsNumber()
  generatorId!: number | null;
  @Type(() => AutoSendMailConfigurationUserType)
  @ValidateNested()
  @Expose()
  autoSendMailConfigurationUserTypes!: Array<AutoSendMailConfigurationUserType>;
}

export class InvoiceSpecification {
  @Expose()
  @IsNumber()
  recordStampId!: number;
  @Expose()
  @IsOptional()
  @IsNumber()
  documentTypeId!: number | null;
  @Type(() => SpecificationColumn)
  @ValidateNested()
  @Expose()
  columns!: Array<SpecificationColumn>;
}

export class AutoSendMailConfigurationModel extends EditAutoSendMailConfiguration {
  @Expose()
  @IsNumber()
  recordStampId!: number;
  @Type(() => InvoiceSpecification)
  @ValidateNested()
  @Expose()
  allInvoices!: InvoiceSpecification;
  @Type(() => InvoiceSpecification)
  @ValidateNested()
  @Expose()
  vatInvoices!: InvoiceSpecification;
  @Type(() => InvoiceSpecification)
  @ValidateNested()
  @Expose()
  vatMarginInvoices!: InvoiceSpecification;
}

export class EditInvoiceSpecification {
  @Expose()
  @IsOptional()
  @IsNumber()
  documentTypeId!: number | null;
  @Type(() => SpecificationColumn)
  @ValidateNested()
  @Expose()
  columns!: Array<SpecificationColumn>;
}

export class SpecificationColumn {
  @Expose()
  @IsString()
  key!: string;
  @Expose()
  @IsOptional()
  @IsString()
  name!: string;
  @Expose()
  @IsOptional()
  @IsNumber()
  attributePrototypeId!: number | null;
  @Expose()
  @IsNumber()
  ordinal!: number;
}
